import $ from 'jquery';

var Modal = {
    selectors: {
        products_compare_modal_body: $('#productsCompareModal .modal-body'),
        products_list_container: $('.products__content-products-wrapper')
    },

    initCompareModal: function () {
//        window.handleProductForCompare('0', false);
    },

    removeProductFromCompareModalListener: function () {
        var selectors = this.selectors;
/*
        $('body').on('click', '#productsCompareModal .remove-product', function(e) {
            var productId = $(this).data('id');
            window.handleProductForCompare(productId, false);

            var unselectedProductContainer = $('.products__content-products-wrapper').find('div[data-id="${productId}"]');
            $(unselectedProductContainer).each(function() {
                $(this).find('.checkbox-label').removeClass('checkbox-checked');
                $(this).find('.checkbox-input').prop('checked', false);
            })
        })
*/
    }
}

export default Modal;
